import { render, staticRenderFns } from "./minigame.vue?vue&type=template&id=5c320df0&lang=pug&"
import script from "./minigame.vue?vue&type=script&lang=js&"
export * from "./minigame.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports